export default "__VITE_ASSET__79c8e174__"